import { useState} from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useGlobalContext } from "../../../Config";
import { noRenovarAsignacion } from "../../../services/CotizacionService.js";

const NoRenovarAsignacionDialog = ({ visible, onHide, idCotizacion, motivosOptions }) => {
    const { baseUrl } = useGlobalContext();
    const [observacionRenovacion, setObservacionRenovacion] = useState("");
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        try {
            const idCreador = sessionStorage.getItem("usuario_id");
            if (!idCreador) throw new Error("Usuario no identificado. Inicia sesión para continuar.");
            await noRenovarAsignacion(baseUrl, {
                idCotizacion,
                idCreador,
                observacion: observacionRenovacion,
            });
            setLoading(false);
            alert("La asignación ha sido marcada como no renovada.");
            window.location.reload();
        } catch (error) {
            setLoading(false);
            console.error(error);
        } finally {
            onHide();
        }
    };

    return (
        <Dialog 
            header="Confirmar No Renovación de Asignación" 
            visible={visible} 
            className="p-fluid product-dialog" 
            modal 
            onHide={onHide} 
            footer={
                <div>
                    <Button label="Cancelar" icon="pi pi-times" className="p-button p-button-rounded p-button-outlined" onClick={onHide} />
                    <Button label="Confirmar" icon={loading ? "pi pi-spin pi-spinner" : "pi pi-check"} className="p-button-success p-button-rounded p-button" raised onClick={handleConfirm} disabled={loading} />
                </div>
            }
        >
            <p className="text-sm text-color-secondary mb-3">
                Confirme la no renovación de la asignación. Seleccione un motivo y haga clic en Confirmar.
            </p>
            <span className="p-float-label mt-2 mb-3">
                <Dropdown id="observacion" value={observacionRenovacion} options={motivosOptions} onChange={(e) => setObservacionRenovacion(e.value)} optionLabel="label" placeholder="Seleccione un motivo de renovación..." className="w-full" required />
                <label htmlFor="observacion">Motivo de la no renovación:</label>
            </span>
        </Dialog>
    );
};

export default NoRenovarAsignacionDialog;
